import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ADD_CALL_FOR_ACTION_ASYNC,
  EDIT_CALL_FOR_ACTION_ASYNC,
} from '../CallForActionForm/constants'

import {
  CALL_FOR_ACTION_REQUEST_ASYNC,
  COPY_CALL_FOR_ACTION_ASYNC,
  DELETE_CALL_FOR_ACTION_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

export default function () {
  const initialState = {
    data: {
      items: [],
    },
    page: 1,
    loader: false,
    error: null,
    search: '',
    message: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
          error: null,
          message: null,
        }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          error: null,
          page: 1,
          message: null,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
          message: null,
          error: null,
        }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          page: 1,
          loader: true,
          message: null,
          error: null,
        }
      case CALL_FOR_ACTION_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
        }
      case CALL_FOR_ACTION_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            items: action.payload.data.items.reduce((acc, cur) => {
              acc[cur.id] = cur
              return acc
            }, {}),
          },
          loader: false,
        }
      case CALL_FOR_ACTION_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: action.error,
        }
      case CALL_FOR_ACTION_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false, page: 1 }
      case DELETE_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
          loader: true,
        }
      case DELETE_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Call To Action Page deleted successfully!',
        }
      case DELETE_CALL_FOR_ACTION_ASYNC.ERROR:
        return {
          ...state,
          error: action.error.detail,
          message: action.error.detail,
          loader: false,
        }
      case COPY_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Call To Action Page copied successfully!',
          loader: true,
        }
      case COPY_CALL_FOR_ACTION_ASYNC.ERROR:
        return {
          ...state,
          error: action.error.detail,
          message: action.error.detail,
          loader: false,
        }
      case ADD_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
        }
      case ADD_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Call To Action Page created successfully!',
        }
      case ADD_CALL_FOR_ACTION_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
        }
      case EDIT_CALL_FOR_ACTION_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
        }
      case EDIT_CALL_FOR_ACTION_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Call To Action Page saved successfully!',
        }
      case EDIT_CALL_FOR_ACTION_ASYNC.CANCEL:
        return {
          ...state,
          message: null,
        }
      default:
        return state
    }
  }
}
